import { IRootState } from '../../../store'
import { IRelationshipsAndGuarantorsState } from '../store/relationshipsAndGuarantors.types'

export const getRelationshipsAndGuarantors = (state: IRootState): IRelationshipsAndGuarantorsState =>
  state.relationshipsAndGuarantors
